import api from '@/api'
import * as types from '../mutation-types'

// initial state
const state = {
  data: [],
  forms: [],
  formGroup: [],
  formKhusus: [],
  fullyloaded: false,
  loading: false
}

// getters
const getters = {
  formData: state => state.data,
  formKhusus: state => state.formKhusus,
  formIsExist: state => (name, kodeGrup) => {
    let query = []
    query = state.forms.filter(form => form.nama_form === name && form.kode_grup_form === kodeGrup)
    if (query.length > 0 && state.fullyloaded) {
      return true
    } else {
      return false
    }
  },
  formGroupIsExist: state => (name) => {
    let query = []
    query = state.formGroup.filter(grup => grup.nama_grup_form === name)
    if (query.length > 0 && state.fullyloaded) {
      return true
    } else {
      return false
    }
  },
  formKhususIsExist: state => () => {
    if (state.formKhusus.length > 0 && state.fullyloaded) {
      return true
    } else {
      return false
    }
  }
}

// actions
const actions = {
  getFormData ({ commit, dispatch, rootState }) {
    commit(types.FORM_LOADING)
    let kodeJalur = rootState.auth.data.mhs_jalur.penawaran_jalur.kode_jalur
    api.get('/v2/grup_jalur_form/' + kodeJalur)
      .then(response => {
        let responseData = response.data
        if (responseData.success) {
          commit(types.RECIEVE_FORM_DATA, responseData.data)
          dispatch('getGrupAktif')
          dispatch('getFormAktif')
        }
      })
      .catch(e => {
        // FIXME: Tell our user when we got some errors
        commit(types.FORM_FINISH_LOADING)
        console.log(e)
      })
  },
  getFormAktif ({ commit, rootState }) {
    let kodeJalur = rootState.auth.data.mhs_jalur.penawaran_jalur.kode_jalur
    api.get('/v2/grup_jalur_form_form/' + kodeJalur)
      .then(response => {
        let responseData = response.data
        if (responseData.success) {
          commit(types.FILTER_FORM, responseData.data)
        }
      })
      .catch(e => {
        // FIXME: Tell our user when we got some errors
        console.log(e)
      })
  },
  getGrupAktif ({ commit, dispatch, rootState }) {
    let kodeJalur = rootState.auth.data.mhs_jalur.penawaran_jalur.kode_jalur
    api.get('/v2/grup_jalur_form_grup/' + kodeJalur)
      .then(response => {
        let responseData = response.data
        if (responseData.success) {
          commit(types.FILTER_GRUP, responseData.data)
          dispatch('getFormKhusus')
        }
      })
      .catch(e => {
        // FIXME: Tell our user when we got some errors
        console.log(e)
      })
  },
  getFormKhusus ({ commit, rootState }) {
    let kodePenawaran = rootState.auth.data.mhs_jalur.penawaran_jalur.kode_penawaran
    api.get('/v2/form_khusus_pj/' + kodePenawaran)
      .then(response => {
        let responseData = response.data
        if (responseData.success) {
          commit(types.RECIEVE_FORM_KHUSUS, responseData.data)
          commit(types.FULLY_LOADED_FORM_DATA)
          commit(types.FORM_FINISH_LOADING)
        }
      })
      .catch(e => {
        // FIXME: Tell our user when we got some errors
        console.log(e)
        commit(types.FULLY_LOADED_FORM_DATA)
        commit(types.FORM_FINISH_LOADING)
      })
  },
  resetFormData ({ commit }) {
    commit(types.RESET_FORM_DATA)
  }
}

// mutations
const mutations = {
  [types.FORM_LOADING] (state) {
    state.loading = true
  },
  [types.FORM_FINISH_LOADING] (state) {
    state.loading = false
  },
  [types.FULLY_LOADED_FORM_DATA] (state) {
    state.fullyloaded = true
  },
  [types.RECIEVE_FORM_DATA] (state, data) {
    state.data = data
  },
  [types.RECIEVE_FORM_KHUSUS] (state, data) {
    state.formKhusus = data
  },
  [types.FILTER_FORM] (state, data) {
    state.forms = data
  },
  [types.FILTER_GRUP] (state, data) {
    state.formGroup = data
  },
  [types.RESET_FORM_DATA] (state) {
    state.data = []
    state.forms = []
    state.formGroup = []
    state.formKhusus = []
    state.loading = false
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/form-data.js